import {
  LoginType,
  LoginResponse,
  User,
  LoginTokensResponse,
  GenericResponse,
  Section,
} from '../types';
import { getHeaders, tosApi } from './tosApi';

type UpdatePasswordType = {
  password: string;
  token: string;
};

type LoginTokensResultResponse = GenericResponse & {
  results: LoginTokensResponse[];
};

export type ParamToken = {
  page?: number;
  page_size?: number;
};

export const authApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<LoginResponse, LoginType>({
      query(login) {
        return {
          url: `/core/auth/login`,
          method: 'POST',
          body: login,
        };
      },
      invalidatesTags: ['TrustedDevices'],
    }),
    getAuthUser: build.query<User | null, null>({
      query: () => {
        return {
          url: `/core/auth/user`,
          method: 'GET',
          headers: getHeaders,
        };
      },
    }),
    getUserSections: build.query<Section[], null>({
      query: () => {
        return {
          url: `/core/auth/user/sections`,
          method: 'GET',
          headers: getHeaders,
        };
      },
    }),
    resetPassword: build.mutation<void, string>({
      query: (email) => ({
        url: '/core/auth/user/reset-password',
        method: 'POST',
        body: { email },
      }),
    }),
    updatePassword: build.mutation<void, UpdatePasswordType>({
      query: (params) => ({
        url: '/core/auth/user/update-password',
        method: 'POST',
        body: { password: params.password },
        headers: { authorization: `Bearer ${params.token}` },
      }),
    }),
    getLoginTokens: build.query<LoginTokensResultResponse, ParamToken | void>({
      query: (params: ParamToken) => {
        return {
          url: `/core/auth/token/tokens`,
          method: 'GET',
          headers: getHeaders,
          params: params || {},
        };
      },
    }),
    revokeToken: build.mutation<void, void>({
      query(token_id) {
        return {
          url: `core/auth/token/tokens/${token_id}/revoke`,
          method: 'POST',
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoginMutation,
  useGetAuthUserQuery,
  useGetUserSectionsQuery,
  useResetPasswordMutation,
  useUpdatePasswordMutation,
  useGetLoginTokensQuery,
  useRevokeTokenMutation,
} = authApi;
